export enum PasswordFailedTypesEnum {
  InvalidCurrentPassword = 'invalid_current_password',
  UnknownFailure = 'unknown_failure',
}
